<template>
  <v-container fluid> 
    <!-- การย้ายข้าราชการครู -->
    <v-hover v-slot="{ hover }">
      <v-card
        :elevation="hover ? 24 : 8"
        :class="{ 'card-hover': hover }"
        class="mission-card teacher-mission mb-6"
        v-if="periodTeachers.period_enable === '1' && periodTeachers.period_type === 'teacher'"
      >
        <div class="mission-stripe teacher"></div>
        <v-card-text class="pa-6">
          <v-row align="center">
            <v-col cols="12" lg="7">
              <div class="mission-content">
                <div class="mission-badge mb-3">
                  <v-chip color="primary" outlined size="small">
                    <v-icon left small>mdi-account</v-icon>
                    ข้าราชการครู
                  </v-chip>
                  <v-chip color="warning" size="small" class="ml-2">
                    <v-icon left small>mdi-swap-horizontal</v-icon>
                    การย้าย
                  </v-chip>
                </div>
                
                <h2 class="mission-title">
                  <v-icon color="primary" class="mr-3">mdi-account-school</v-icon>
                  ยื่นคำร้องขอย้าย ข้าราชการครู
                </h2>
                
                <div class="mission-details">
                  <div class="detail-item">
                    <v-icon small color="success" class="mr-2">mdi-check-circle</v-icon>
                    <span>สามารถดำเนินการยื่นคำร้องขอย้ายได้แล้ว</span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="primary" class="mr-2">mdi-calendar-check</v-icon>
                    <span>ก่อนระบบปิดในวันที่ 
                      <strong class="text-error">
                        {{ periodTeachers.period_stop | moment("add", "543 years") | moment("D MMMM YYYY") }}
                      </strong>
                      เวลา 16.30 น.
                    </span>
                  </div>
                </div>               
                
              </div>
            </v-col>
            <v-col cols="12" lg="5">
              <div class="countdown-container">
                <div class="countdown-header">
                  <h4 class="countdown-title">
                    <v-icon small color="primary">mdi-clock-alert</v-icon>
                    ปิดระบบยื่นคำร้องขอย้าย
                  </h4>
                  <div class="deadline-date">
                    {{ periodTeachers.period_stop | moment("add", "543 years") | moment("D MMMM YYYY") }}
                  </div>
                  <p class="deadline-time">เวลา 16.30 น.</p>
                  <p class="countdown-label">เหลือเวลาอีก</p>
                </div>
                <div class="countdown-timer">
                  <flip-countdown
                    :deadline="periodTeachers.period_stop + ' 16:30:00'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-hover>

    <!-- การย้ายบุคลากรมาตรา 38 -->
    <v-hover v-slot="{ hover }">
      <v-card
        :elevation="hover ? 24 : 8"
        :class="{ 'card-hover': hover }"
        class="mission-card personnel-38-mission mb-6"
        v-if="period_38.period_enable === '1'"
      >
        <div class="mission-stripe personnel-38"></div>
        <v-card-text class="pa-6">
          <v-row align="center">
            <v-col cols="12" lg="7">
              <div class="mission-content">
                <div class="mission-badge mb-3">
                  <v-chip color="purple" outlined size="small">
                    <v-icon left small>mdi-account-star</v-icon>
                    มาตรา 38 ค.(2)
                  </v-chip>
                  <v-chip color="warning" size="small" class="ml-2">
                    <v-icon left small>mdi-swap-horizontal</v-icon>
                    การย้าย
                  </v-chip>
                </div>
                
                <h2 class="mission-title">
                  <v-icon color="purple" class="mr-3">mdi-account-star-outline</v-icon>
                  บุคลากรทางการศึกษาอื่น ตามมาตรา 38 ค.(2)
                </h2>
                
                <div class="mission-details">
                  <div class="detail-item">
                    <v-icon small color="success" class="mr-2">mdi-check-circle</v-icon>
                    <span>สามารถดำเนินการยื่นคำร้องขอย้ายได้แล้ว</span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="primary" class="mr-2">mdi-calendar-check</v-icon>
                    <span>ก่อนระบบปิดในวันที่ 
                      <strong class="text-error">
                        {{ period_38.period_stop | moment("add", "543 years") | moment("D MMMM YYYY") }}
                      </strong>
                      เวลา 16.30 น.
                    </span>
                  </div>
                  <div class="detail-item">
                    <v-icon small color="info" class="mr-2">mdi-information</v-icon>
                    <span class="text-info">สำหรับบุคลากรทางการศึกษาอื่นตามมาตรา 38 ค.(2)</span>
                  </div>
                </div>
                
                <div class="action-section mt-4">
                  <v-btn 
                    color="purple" 
                    class="action-btn mr-3"
                    rounded
                    large
                    @click="openPersonnel38Application"
                  >
                    <v-icon left>mdi-file-document</v-icon>
                    ยื่นคำร้องขอย้าย
                  </v-btn>
                  <v-btn 
                    color="indigo" 
                    outlined
                    class="action-btn"
                    rounded
                    large
                    @click="viewPersonnel38Status"
                  >
                    <v-icon left>mdi-eye</v-icon>
                    ตรวจสอบสถานะ
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="5">
              <div class="countdown-container">
                <div class="countdown-header">
                  <h4 class="countdown-title">
                    <v-icon small color="purple">mdi-clock-alert</v-icon>
                    ปิดระบบยื่นคำร้องขอย้าย
                  </h4>
                  <div class="deadline-date">
                    {{ period_38.period_stop | moment("add", "543 years") | moment("D MMMM YYYY") }}
                  </div>
                  <p class="deadline-time">เวลา 16.30 น.</p>
                  <p class="countdown-label">เหลือเวลาอีก</p>
                </div>
                <div class="countdown-timer">
                  <flip-countdown
                    :deadline="period_38.period_stop + ' 16:30:00'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-hover>
  </v-container>
</template>

<script>
import FlipCountdown from "vue2-flip-countdown";

export default {
  name: "HRvecAlertMissionPersonnelTeach",
  components: { FlipCountdown },
  
  data() {
    return {
      ApiKey: "HRvec2021",
      periodTeachers: [],
      period_38: [],
      labels: {
        days: "วัน",
        hours: "ชั่วโมง",
        minutes: "นาที",
        seconds: "วินาที"
      }
    };
  },

  async mounted() {
    await this.periodQueryTeacher();
    await this.periodQuery_38();
  },
  methods: {
    async periodQueryTeacher() {
      let result;
      result = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_enable: "1",
        period_type: "teacher"
      });
      this.periodTeachers = result.data;

      if (this.periodTeachers.period_enable == "1") {
        let dateNow = new Date();
        let dateStop = new Date(this.periodTeachers.period_stop + " 16:30:00");
        this.dateNows = dateNow.getTime();
        this.dateStops = dateStop.getTime();
        this.interval = setInterval(async () => {
          if (this.dateNows > this.dateStops) {
            this.periodTeachers.ApiKey = this.ApiKey;
            this.periodTeachers.period_enable = "0";
            await this.$http.post("period.update.php", this.periodTeachers);
            await this.periodQueryTeacher();
          }
        }, 3000);
      }
    },

    async periodQuery_38() {
      let result;
      result = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_enable: "1",
        period_college_id: "38101"
      });
      this.period_38 = result.data;
      
      if (this.period_38.period_enable == "1") {
        let dateNow = new Date();
        let dateStop = new Date(this.period_38.period_stop + " 16:30:00");
        this.dateNows = dateNow.getTime();
        this.dateStops = dateStop.getTime();
        this.interval = setInterval(async () => {
          if (this.dateNows > this.dateStops) {
            this.period_38.ApiKey = this.ApiKey;
            this.period_38.period_enable = "0";
            await this.$http.post("period.update.php", this.period_38);
            await this.periodQuery_38();
          }
        }, 3000);
      }
    },

    // User Actions for Teachers
    openTeacherApplication() {
      // Navigate to teacher application form
      this.$router.push('/teacher/application/transfer');
    },

    viewTeacherStatus() {
      // Navigate to teacher status page
      this.$router.push('/teacher/status');
    },

    // User Actions for Personnel 38
    openPersonnel38Application() {
      // Navigate to personnel 38 application form
      this.$router.push('/personnel38/application/transfer');
    },

    viewPersonnel38Status() {
      // Navigate to personnel 38 status page
      this.$router.push('/personnel38/status');
    }
  },

  beforeDestroy() {
    // Clear intervals when component is destroyed
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
};
</script>

<style scoped>
/* Thai Font */
* {
  font-family: 'Sarabun', 'Roboto', sans-serif !important;
}

/* Container */
.personnel-teach-container {
  padding: 1rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 50%, #f1f5f9 100%);
  min-height: 100vh;
}

/* Dashboard Header */
.dashboard-header {
  background: linear-gradient(135deg, #059669 0%, #047857 50%, #065f46 100%);
  color: white;
  padding: 3rem 2rem;
  border-radius: 25px;
  text-align: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(5, 150, 105, 0.2);
}

.dashboard-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="20" cy="20" r="1.5" fill="rgba(255,255,255,0.15)"/><circle cx="80" cy="40" r="2" fill="rgba(255,255,255,0.1)"/><circle cx="40" cy="80" r="1" fill="rgba(255,255,255,0.12)"/><circle cx="60" cy="15" r="1.2" fill="rgba(255,255,255,0.08)"/></svg>');
  pointer-events: none;
}

.header-content {
  position: relative;
  z-index: 1;
}

.header-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.header-subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
  margin: 0;
}

/* Mission Cards */
.mission-card {
  border-radius: 20px !important;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  overflow: hidden;
  background: linear-gradient(145deg, #ffffff 0%, #fefefe 50%, #fdfdfd 100%);
  border: 1px solid rgba(226, 232, 240, 0.8);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.mission-card.card-hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.12) !important;
}

/* Mission Stripes */
.mission-stripe {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  z-index: 1;
}

.mission-stripe.teacher {
  background: linear-gradient(45deg, #3b82f6, #1d4ed8);
  box-shadow: 0 0 20px rgba(59, 130, 246, 0.3);
}

.mission-stripe.personnel-38 {
  background: linear-gradient(45deg, #a855f7, #7c3aed);
  box-shadow: 0 0 20px rgba(168, 85, 247, 0.3);
}

/* Mission Content */
.mission-content {
  padding-left: 25px;
}

.mission-badge {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.mission-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 1rem;
  line-height: 1.4;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

/* Mission Details */
.mission-details {
  margin-top: 1.2rem;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.8rem;
  font-size: 1rem;
  line-height: 1.6;
  color: #475569;
}

.detail-item:last-child {
  margin-bottom: 0;
}

/* Action Section */
.action-section {
  margin-top: 1.8rem;
}

.action-btn {
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
  min-height: 48px !important;
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.2) !important;
  min-width: 160px;
  border-radius: 12px !important;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(59, 130, 246, 0.3) !important;
}

/* Countdown Container */
.countdown-container {
  text-align: center;
  padding: 2.5rem;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 50%, #e2e8f0 100%);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(148, 163, 184, 0.2);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);
}

.countdown-header {
  margin-bottom: 1.8rem;
}

.countdown-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.deadline-date {
  font-size: 1.2rem;
  font-weight: 700;
  color: #059669;
  margin-bottom: 0.3rem;
}

.deadline-time {
  font-size: 1rem;
  font-weight: 600;
  color: #ef4444;
  margin-bottom: 0.6rem;
}

.countdown-label {
  font-size: 0.95rem;
  color: #64748b;
  margin: 0;
  font-weight: 500;
}

.countdown-timer {
  margin: 2rem 0;
}

.countdown-timer >>> .flip-countdown {
  display: flex;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
}

.countdown-timer >>> .flip-countdown__piece {
  background: linear-gradient(145deg, #ffffff, #f8fafc) !important;
  color: #1e293b !important;
  border-radius: 15px !important;
  font-weight: 700 !important;
  font-size: 1.5rem !important;
  min-width: 65px !important;
  height: 65px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.8) !important;
  border: 2px solid rgba(226, 232, 240, 0.8) !important;
}

.countdown-timer >>> .flip-countdown__slot {
  font-size: 0.9rem !important;
  color: #64748b !important;
  margin-top: 10px !important;
  font-weight: 600 !important;
}

/* Info Cards */
.info-section {
  margin-top: 3rem;
}

.info-card {
  border-radius: 15px !important;
  background: linear-gradient(145deg, #ffffff, #f8fafc) !important;
  border: 1px solid rgba(226, 232, 240, 0.6);
  transition: all 0.3s ease;
}

.info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1) !important;
}

.info-card-title {
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  color: #1e293b !important;
  font-weight: 600 !important;
  border-bottom: 1px solid rgba(226, 232, 240, 0.6);
}

.info-list {
  padding: 0;
}

.info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #475569;
}

.info-item:last-child {
  margin-bottom: 0;
}

/* Text Utilities */
.text-error {
  color: #ef4444 !important;
  font-weight: 600;
}

.text-primary {
  color: #3b82f6 !important;
  font-weight: 600;
}

.text-info {
  color: #06b6d4 !important;
  font-weight: 600;
}

.text-success {
  color: #10b981 !important;
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .header-title {
    font-size: 2.2rem;
  }
  
  .mission-title {
    font-size: 1.4rem;
  }
}

@media (max-width: 768px) {
  .dashboard-header {
    padding: 2rem 1rem;
    border-radius: 15px;
  }
  
  .header-title {
    font-size: 1.8rem;
  }
  
  .header-subtitle {
    font-size: 1rem;
  }
  
  .mission-title {
    font-size: 1.3rem;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .action-btn {
    width: 100%;
    margin-bottom: 0.5rem;
    min-width: auto;
  }
  
  .countdown-container {
    margin-top: 2rem;
    padding: 1.5rem;
  }
  
  .countdown-timer >>> .flip-countdown__piece {
    min-width: 50px !important;
    height: 50px !important;
    font-size: 1.2rem !important;
  }
}

@media (max-width: 600px) {
  .personnel-teach-container {
    padding: 0.5rem;
  }
  
  .mission-card {
    margin-bottom: 1.5rem;
  }
  
  .detail-item {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .detail-item .v-icon {
    margin-bottom: 4px;
  }
  
  .mission-badge {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .countdown-timer >>> .flip-countdown {
    gap: 8px;
  }
  
  .countdown-timer >>> .flip-countdown__piece {
    min-width: 45px !important;
    height: 45px !important;
    font-size: 1rem !important;
  }
}

/* Animation Effects */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mission-card {
  animation: fadeInUp 0.6s ease-out;
}

.mission-card:nth-child(2) { animation-delay: 0.1s; }
.mission-card:nth-child(3) { animation-delay: 0.2s; }

.info-card {
  animation: fadeInUp 0.6s ease-out;
  animation-delay: 0.3s;
  animation-fill-mode: both;
}

/* Vuetify Overrides */
.v-chip.v-chip--outlined {
  border-width: 2px !important;
  font-weight: 600 !important;
}

.v-btn {
  text-transform: none !important;
}

/* Focus States for Accessibility */
.action-btn:focus {
  outline: 3px solid rgba(59, 130, 246, 0.5);
  outline-offset: 2px;
}

.mission-card:focus-within {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
}

/* Loading States */
.loading-shimmer {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* Enhanced Mission Cards Effects */
.mission-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%);
  transform: translateX(-100%);
  transition: transform 0.6s;
  pointer-events: none;
}

.mission-card:hover::before {
  transform: translateX(100%);
}

/* Special Chip Styles */
.v-chip.v-size--small {
  font-size: 0.75rem !important;
  height: 24px !important;
}

/* Custom Badge Animations */
.mission-badge .v-chip {
  transition: all 0.3s ease;
}

.mission-badge .v-chip:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

/* Status Indicators */
.status-indicator {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
}

.status-indicator.active {
  background-color: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.status-indicator.pending {
  background-color: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}

.status-indicator.expired {
  background-color: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

/* Gradient Text Effects */
.gradient-text {
  background: linear-gradient(45deg, #059669, #047857);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 700;
}

/* Enhanced Countdown Styling */
.countdown-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, rgba(255,255,255,0.2) 0%, transparent 70%);
  border-radius: 20px;
  pointer-events: none;
}

/* Micro-interactions */
.detail-item:hover .v-icon {
  transform: scale(1.1);
  transition: transform 0.2s ease;
}

.mission-title:hover .v-icon {
  transform: rotate(5deg) scale(1.1);
  transition: transform 0.3s ease;
}

/* Info Card Enhancements */
.info-card .v-card__title {
  border-radius: 15px 15px 0 0 !important;
}

.info-item:hover {
  background: rgba(59, 130, 246, 0.05);
  border-radius: 8px;
  padding: 8px;
  margin: 0 -8px 8px -8px;
  transition: all 0.2s ease;
}

/* Button Group Styles */
.action-section .action-btn + .action-btn {
  margin-left: 0 !important;
  margin-top: 0.5rem;
}

@media (min-width: 600px) {
  .action-section .action-btn + .action-btn {
    margin-left: 1rem !important;
    margin-top: 0;
  }
}

/* Dark mode support (if needed) */
@media (prefers-color-scheme: dark) {
  .mission-card {
    background: linear-gradient(145deg, #2c3e50 0%, #34495e 100%);
    color: white;
  }
  
  .mission-title {
    color: #ecf0f1;
  }
  
  .countdown-title {
    color: #ecf0f1;
  }
  
  .detail-item {
    color: #bdc3c7;
  }
  
  .info-card {
    background: linear-gradient(145deg, #2c3e50, #34495e) !important;
    color: white;
  }
  
  .info-card-title {
    background: linear-gradient(135deg, #34495e, #2c3e50);
    color: #ecf0f1 !important;
  }
}

/* Print Styles */
@media print {
  .mission-card {
    break-inside: avoid;
    box-shadow: none !important;
    border: 1px solid #ccc;
  }
  
  .countdown-timer {
    display: none;
  }
  
  .action-btn {
    display: none;
  }
  
  .dashboard-header {
    background: #f8f9fa !important;
    color: black !important;
  }
}

/* High contrast mode */
@media (prefers-contrast: high) {
  .mission-card {
    border: 2px solid #000;
  }
  
  .mission-stripe {
    width: 8px;
  }
  
  .text-error {
    color: #cc0000 !important;
  }
  
  .text-success {
    color: #006600 !important;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .mission-card {
    animation: none;
    transition: none;
  }
  
  .action-btn:hover {
    transform: none;
  }
  
  .mission-card.card-hover {
    transform: none;
  }
}
</style>